export const confirmEn = {
  'confirm.confirmTitle': 'Verify your email',
  // 'confirm.placeholder.email': 'email@example.com',
  // 'confirm.label.email': 'Email',
  // 'confirm.placeholder.code': '1234',
  // 'confirm.label.code': 'Code',
  'confirm.enterCode': 'Enter the verification code sent to',
  'confirm.buttom.login': 'Verify',

  // 'confirm.errors.email.required': 'Please enter your email address',
  // 'confirm.errors.email.invalid': 'Please enter a valid email address',
  // 'confirm.errors.code.required': 'Please enter the verification code',

  'confirm.loading': 'Verifying email...',
  'confirm.error': 'Incorrect verification code',
  'confirm.success': 'Your email has been verified',

  'confirm.didNotReceiveCode': "Didn't receive the code?",
  'confirm.resendCode': 'Resend code',

  'confirm.resendingCode': 'Resending code...',
  'confirm.resentError': 'Failed to resend code',
  'confirm.successResend': 'Code resent',
};

export const confirmEs = {
  'confirm.confirmTitle': 'Verifica tu correo',
  // 'confirm.placeholder.email': 'email@example.com',
  // 'confirm.label.email': 'Correo',
  // 'confirm.placeholder.code': '1234',
  // 'confirm.label.code': 'Código',
  'confirm.enterCode': 'Ingresa el código de verificación enviado a',
  'confirm.buttom.login': 'Verificar',

  // 'confirm.errors.email.required': 'Por favor ingresa tu correo',
  // 'confirm.errors.email.invalid': 'Por favor ingresa un correo válido',
  // 'confirm.errors.code.required': 'Por favor ingresa el código de verificación',

  'confirm.loading': 'Verificando correo...',
  'confirm.error': 'Código de verificación incorrecto',
  'confirm.success': 'Tu correo ha sido verificado',

  'confirm.didNotReceiveCode': '¿No recibiste el código?',
  'confirm.resendCode': 'Reenviar código',

  'confirm.resendingCode': 'Reenviando código...',
  'confirm.resentError': 'Error al reenviar código',
  'confirm.successResend': 'Código reenviado',
};
